import React from 'react';

function Chile(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124162)">
        <mask
          id="mask0_800_124162"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124162)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H15.75V14H0V0Z"
            fill="#3D58DB"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.75 -2H36V14H15.75V-2Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 14H36V24H0V14Z"
            fill="#E31D1C"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.8913 9.78332L3.61218 12.0548L5.72399 8.18995L1.98438 5.67975L6.30155 5.63865L7.9302 2.21143L8.97884 5.63865L13.0651 5.65578L9.95715 8.11094L11.571 12.0548L7.8913 9.78332Z"
            fill="#F7FCFF"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124162">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Chile;
